import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";


// Note: React.StrictMode is not enabled because some useful controls
// from Material UI are not compatible with it. For example, Dialogs.
ReactDOM.render(
  <App />,
  document.getElementById("root")
);
